import { useNavigate } from "react-router-dom";
import { useFetch } from "../../hooks/useFetch";

const RedirectToLogin = () => {
  const navigate = useNavigate();

  useFetch(() => {
    navigate("/login?redirect=" + window.location.pathname);
  });
  return <></>;
};
export default RedirectToLogin;
